
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsAdvPromoHdDialog extends Serenity.EntityDialog<PsAdvPromoHdRow, any> {
        protected getFormKey() { return PsAdvPromoHdForm.formKey; }
        protected getIdProperty() { return PsAdvPromoHdRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoHdRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoHdRow.nameProperty; }
        protected getService() { return PsAdvPromoHdService.baseUrl; }
        protected getDeletePermission() { return PsAdvPromoHdRow.deletePermission; }
        protected getInsertPermission() { return PsAdvPromoHdRow.insertPermission; }
        protected getUpdatePermission() { return PsAdvPromoHdRow.updatePermission; }

        protected form = new PsAdvPromoHdForm(this.idPrefix);

        constructor() {
            super();
            

            this.form.PromoTimeFg.changeSelect2(e => {
                var setpromotimefg = this.setPromoTimeFg;
                var setpromotimefgn = this.setPromoTimeFgn;
                if (setpromotimefg) {
                    Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, true);
                    Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, true);
                } 
                if (setpromotimefgn){
                    Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, false);
                    Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, false);
                    this.form.StartPromoTime.value = null
                    this.form.StartPromoTime.value = null
                }
            });

            this.form.PromoDayFg.changeSelect2(e => {
                var setpromodayfg = this.setPromoDayFg;
                var setpromodayfgn = this.setPromoDayFgn;
                if (setpromodayfg) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoDay, true);
                } 
                if (setpromodayfgn) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoDay, false);
                    this.form.PromoDay.value = null
                }
            });

            this.form.PromoShopFg.changeSelect2(e => {
                var setpromoshopfg = this.setPromoShopFg;
                var setpromoshopfgn = this.setPromoShopFgn;
                if (setpromoshopfg) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoShop, true);
                } 
                if (setpromoshopfgn) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoShop, false);
                    this.form.PromoShop.value = null
                }
            });
            this.form.PromoCustFg.changeSelect2(e => {
                let CusFg = Q.toId(this.form.PromoCustFg.value)
                console.log(Q.toId(this.form.PromoCustFg.value))
                if (CusFg == 3) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoMb, false);
                } 
                if(CusFg == 1) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                    this.form.PromoMb.value = null
                }
                if(CusFg == 2) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                    this.form.PromoMb.value = null
                }
                if(CusFg == 0) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                    this.form.PromoMb.value = null
                }else if(CusFg == null){
                    Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                    this.form.PromoMb.value = null
                }
            });
            
        }
        private get setPromoTimeFg() {
            return this.form.PromoTimeFg.value != "1";
        }

        private get setPromoDayFg() {
            return this.form.PromoDayFg.value != "1";
        }

        private get setPromoShopFg() {
            return this.form.PromoShopFg.value != "1";
        }
        private get setPromoTimeFgn() {
            return this.form.PromoTimeFg.value != "0";
        }

        private get setPromoDayFgn() {
            return this.form.PromoDayFg.value != "0";
        }

        private get setPromoShopFgn() {
            return this.form.PromoShopFg.value != "0";
        }
        
       
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            if(this.isNew){
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.syscuscheck();
            
            if (this.isNew) {

                Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, true);
                Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoDay, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoShop, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);

                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-apply').hide();
            }
            if (this.entity.PromoApproveFg == 1) {
                Serenity.EditorUtils.setReadOnly(this.form.PromoDayFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoCustFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, true);
                Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoDay, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoShop, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoShopFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoTimeFg, true);
                Serenity.EditorUtils.setReadOnly(this.form.PmGroupId, true);
                Serenity.EditorUtils.setReadOnly(this.form.PmGroupDesc, true);
                
                Serenity.EditorUtils.setReadOnly(this.form.EndPromoDate, true);
                Serenity.EditorUtils.setReadOnly(this.form.StartPromoDate, true);

                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('apply-changes-button').hide();
                this.toolbar.findButton('save-and-close-button').hide();
            }
            else{
                if (this.isEditMode){
                    this.toolbar.findButton('delete-button').show();
                    this.toolbar.findButton('apply-changes-button').show();
                    
                    let CusFg = Q.toId(this.form.PromoCustFg.value)
                    var setpromotimefg = this.setPromoTimeFg;
                    var setpromotimefgn = this.setPromoTimeFgn;
                    var setpromodayfg = this.setPromoDayFg;
                    var setpromodayfgn = this.setPromoDayFgn;
                    var setpromoshopfg = this.setPromoShopFg;
                    var setpromoshopfgn = this.setPromoShopFgn;
                    console.log(CusFg)
                    if (setpromotimefg) {
                        Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, true);
                        Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, true);
                    } 
                    if (setpromotimefgn){
                        Serenity.EditorUtils.setReadOnly(this.form.StartPromoTime, false);
                        Serenity.EditorUtils.setReadOnly(this.form.EndPromoTime, false);                    
                    }
                    if (setpromodayfg) {
                        Serenity.EditorUtils.setReadOnly(this.form.PromoDay, true);
                    } 
                    if (setpromodayfgn) {
                        Serenity.EditorUtils.setReadOnly(this.form.PromoDay, false);
                    }            
                    if (setpromoshopfg) {
                        Serenity.EditorUtils.setReadOnly(this.form.PromoShop, true);
                    } 
                    if (setpromoshopfgn) {
                        Serenity.EditorUtils.setReadOnly(this.form.PromoShop, false);
                    }
                    if(CusFg >= 2 && null) {
                        Serenity.EditorUtils.setReadOnly(this.form.PromoMb, true);
                        
                    }
                    if(CusFg === 3){
                        Serenity.EditorUtils.setReadOnly(this.form.PromoMb, false);
                        
                    }}

            }
        }

        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 13 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.VenderSharing.getGridField().toggle(true);
            } else {
                this.form.VenderSharing.getGridField().toggle(false);
            }

        }

    }
}